<div *ngIf="!machCore" class="logo">
  <img *ngIf="logoUrl" [src]="logoUrl" [alt]="altText" class="redIcon" />
</div>

<div *ngIf="machCore" class="flex justify-end">
  <div class="logo">
    <img *ngIf="logoUrl" [src]="logoUrl" [alt]="altText" class="redIcon" />
  </div>
  <svg
    class="absolute right-[8px] top-[16px] cursor-pointer"
    (click)="triggerClose.emit()"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.001 4.16016L13.1494 12.001L20.9971 19.8398L19.835 21.001L11.9873 13.1621L4.16504 20.9766L3.00293 19.8164L10.8262 12.002L3 4.18457L4.16211 3.02344L11.9883 10.8408L19.8389 3L21.001 4.16016Z"
      fill="#6C718A"
    />
  </svg>
</div>
